import React, { useEffect } from "react";
import Vehicle_Request from "../../../../client/assets/images/Vehicle Request.svg";
import ManagedEquipment from "../../../../client/assets/images/Managed Equipment.svg";
import NonStandard_Equipment from "../../../../client/assets/images/Non-Standard Equipment.svg";
import { useDispatch, useSelector } from "react-redux";
import "./Ordertypepopup.scss";
import navOperations from "../../../../redux/Navigation/operations";
import myOrderSelectors from "../../../../redux/MyOrder/selectors";
import {
  setAssetTypeId,
  setAssetTypeText,
  setOrderDetails,
  setOrderId,
  setSelectedReasonType,
  showCatalogItemDetails,
} from "../../../../redux/MyOrder/action";
import nonStandardEquipmentOperations from "../../../../redux/NonStandardEquipment/operations";
import { operations as customerMyOrderOperations } from "redux/CustomerMyOrder";
import { v1 as uuid } from "uuid";

interface IProps {
  setShowPopup?: any;
}

const OrderTypePopup = ({ setShowPopup }: IProps) => {
  const dispatch = useDispatch();
  const dispatchNav = navOperations.dispatchNav(dispatch);
  const dispatchActionColumn =
    customerMyOrderOperations.dispatchActionColumn(dispatch);
  const dispatchSetIsSubmitted =
    nonStandardEquipmentOperations.dispatchSetIsSubmitted(dispatch);
  const AssetTypes = useSelector((state) => ({
    AssetTypes: myOrderSelectors.getAssettypes(state),
  }));
  const { orderDetails }: any = useSelector((state: any) => ({
    orderDetails: myOrderSelectors.orderDetails(state),
  }));
  const assetTypes = {
    Vehicle_Request: "Vehicle Request",
    Managed_Equipment: "Managed Equipment",
    NonStandard_Equipment: "Non-Standard Equipment"
  }

  useEffect(() => {
    setShowPopup(
      !!(
        Array.isArray(AssetTypes.AssetTypes) &&
        AssetTypes.AssetTypes?.length > 0
      )
    );
  }, [JSON.stringify(AssetTypes.AssetTypes)]);

  const handleClick = (item: any) => {
    let setItem = "";
    if (item.text === assetTypes.Vehicle_Request) {
      setItem = "My Orders";
      dispatchNav(setItem);
    } else if (item.text === assetTypes.Managed_Equipment) {
      setItem = "Managed Equipment";
      dispatchNav(setItem);
    } else if (item.text === assetTypes.NonStandard_Equipment) {
      setItem = "Non-Standard Equipment";
      dispatchSetIsSubmitted(false);
      dispatchNav(setItem);
    }
    orderDetails.directoryName = uuid();
    orderDetails.requests = [];
    dispatch(setOrderDetails(orderDetails));
    dispatch(showCatalogItemDetails(false));
    dispatch(setSelectedReasonType(""));
    dispatch(setAssetTypeText(item.text));
    dispatch(setAssetTypeId(item.value));
    dispatch(setOrderId(null));
    dispatchActionColumn(false);
  };

  return (
    <div className="order-type-popup">
      {Array.isArray(AssetTypes.AssetTypes) &&
        AssetTypes.AssetTypes.map((val: any, index: any) => (
          <div
            className="Ordertypedetails seperator"
            onClick={() => handleClick(val)}
            key={index}
          >
            <img
              src={
                val.text === assetTypes.Vehicle_Request
                  ? Vehicle_Request
                  : val.text === assetTypes.Managed_Equipment
                  ? ManagedEquipment
                  : val.text === assetTypes.NonStandard_Equipment
                  ? NonStandard_Equipment
                  : null
              }
              alt="btn-icon"
            />
            <span>{val.text}</span>
          </div>
        ))}
    </div>
  );
};

export default OrderTypePopup;

function i(): React.ReactNode {
  throw new Error("Function not implemented.");
}
